<template>
    <div>
        <section class="row justify-content-center align-content-center" id="search-engine-section">
            <div class="col-12" :class="siteCols">
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <h3>{{ $t('searchEngineSection.title') }}</h3>
                        <p v-html="$t('searchEngineSection.description')"></p>

                        <a href="#search-engine-section-2" class="btn mt-4">{{ $t('moreInformation') }}</a>
                    </div>
                </div>
            </div>
        </section>

        <section class="row justify-content-center align-content-center generic-section" :class="{ expanded: searchEngine2Expanded }" id="search-engine-section-2">
            <div class="col-12 p-relative" :class="siteCols">
                <div class="row align-items-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-12">
                                <h3 class="mb-4">{{ $t('searchEngine2Section.title') }}</h3>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-md-7 col-lx-5 pl-4">
                                <img src="../assets/img/item-smart-phones-1.jpg" class="d-block d-md-none mx-auto my-4 w-75">
                                <p v-html="$t('searchEngine2Section.description')"></p>
                            </div>

                            <div class="col-12 d-none d-md-block col-md-5 col-lx-7">
                                <img src="../assets/img/item-smart-phones-1.jpg" class="w-100">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="col-12 mt-0 mt-md-3">
                        <p v-html="$t('searchEngine2Section.description2')"></p>
                    </div>
                </div>

                <div class="row align-items-center mt-0 mt-md-3">
                    <div class="col-12 col-md-4 col-lx-3 text-center text-md-center">
                        <img src="../assets/img/item-smart-phones-2.jpg" class="w-75 w-md-100">
                    </div>

                    <div class="col-12 col-md-8 col-lx-9">
                        <p v-html="$t('searchEngine2Section.description3')"></p>
                    </div>
                </div>

                <div class="btn mt-4 d-none" id="more-information" v-if="!searchEngine2Expanded" @click="expandSearchEngine2">{{ $t('more') }}</div>
            </div>
        </section>

        <section class="row justify-content-center generic-section" id="daily-stats-section">
            <div class="col-12 text-center" :class="siteCols">
                <div class="row">
                    <div class="col-12">
                        <h3>{{ $t('dailyStatsSection.title') }}</h3>
                    </div>
                </div>

                <div class="row">
                    <div v-for="stat in stats" :key="stat.key" class="col-12 col-md-4">
                        <i class="icon" :class="stat.icon"></i>
                        <span class="stat-label">{{ $t(stat.name) }}</span>
                        <span class="stat-num">{{ stat.num }}</span>
                    </div>
                </div>
            </div>
        </section>

        <section class="row justify-content-center generic-section align-content-center" id="keywords-section">
            <div class="col-12" :class="siteCols">
                <!--<div class="row">
                    <div class="col-12">
                        <span class="badge">{{ $t('keywordSection.features') }}</span>
                    </div>
                </div>-->

                <div class="row">
                    <div class="col-12 col-md-6 pl-4">
                        <h3>{{ $t('keywordSection.title') }}</h3>
                        <img src="../assets/img/item-store-art.jpg" class="d-block d-md-none mx-auto my-4 w-75">
                        <p>{{ $t('keywordSection.description') }}</p>
                    </div>

                    <div class="col-12 col-md-6">
                        <img src="../assets/img/item-store-art.jpg" class="d-none d-md-block mr-auto w-85">
                    </div>
                </div>
            </div>
        </section>

        <section class="row justify-content-center generic-section align-content-center" id="quotes-section">
            <div class="col-12" :class="siteCols">
                <div class="row align-items-center">
                    <div class="col-12 col-md-6 col-lg-5">
                        <div class="gif-video d-none d-md-block">
                            <img src="../assets/img/item-art1.svg">

                            <video autoplay loop>
                                <source src="../assets/video/video-2.mp4" type="video/mp4">
                            </video>

                            <img src="../assets/img/item-phone.svg">
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-7 pr-md-5">
                        <h3>{{ $t('quotesSection.title') }}</h3>

                        <div class="gif-video d-block d-md-none mx-auto my-4 w-100">
                            <img src="../assets/img/item-art1.svg">

                            <video autoplay loop>
                                <source src="../assets/video/video-2.mp4" type="video/mp4">
                            </video>

                            <img src="../assets/img/item-phone.svg">
                        </div>

                        <p>{{ $t('quotesSection.description') }}</p>
                    </div>
                </div>
            </div>
        </section>

        <!--<section class="row justify-content-center generic-section align-content-center" id="new-apps-section">
            <div class="col-12 text-center" :class="siteCols">
                <h3>{{ $t('newAppsSection.title') }}</h3>
                <p>{{ $t('newAppsSection.description') }}</p>
            </div>
        </section>-->

        <section class="row justify-content-center generic-section align-content-center my-4" id="forecast-section">
            <div class="col-12" :class="siteCols">
                <div class="row align-items-center">
                    <div class="col-12 col-md-6 col-lg-7 pl-md-5">
                        <h3>{{ $t('forecastSection.title') }}</h3>

                        <div class="gif-video d-block d-md-none mx-auto my-4 w-100">
                            <img src="../assets/img/item-art-4.svg">

                            <video autoplay loop>
                                <source src="../assets/video/video-1.mp4" type="video/mp4">
                            </video>

                            <img src="../assets/img/item-phone.svg">
                        </div>

                        <p v-html="$t('forecastSection.description')"></p>
                    </div>

                    <div class="col-12 col-md-6 col-lg-5 text-center">
                        <div class="gif-video d-none d-md-block mr-auto">
                            <img src="../assets/img/item-art-4.svg">

                            <video autoplay loop>
                                <source src="../assets/video/video-1.mp4" type="video/mp4">
                            </video>

                            <img src="../assets/img/item-phone.svg">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--<section class="row justify-content-center generic-section align-content-center" id="indexer-section">
            <div class="col-12 text-center text-md-right" :class="siteCols">
                <div class="row align-items-center">
                    <div class="col-12 col-md-6 col-lg-4 text-center">
                        <img src="../assets/img/item-indexer.jpg" class="d-none d-md-block w-85">
                    </div>

                    <div class="col-12 col-md-6 col-lg-8 pt-4 pl-md-5">
                        <h3>{{ $t('indexerSection.title') }}</h3>
                        <img src="../assets/img/item-indexer.jpg" class="d-block d-md-none mx-auto my-4 w-50">
                        <p v-html="$t('indexerSection.description1')"></p>
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="col-12 col-md-6 col-lg-8 pt-4 pr-md-5">
                        <img src="../assets/img/item-smart-phones-light.jpg" class="d-block d-md-none mx-auto my-4 w-50">
                        <p v-html="$t('indexerSection.description2')"></p>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4 text-center">
                        <img src="../assets/img/item-smart-phones-light.jpg" class="d-none d-md-block w-85">
                    </div>
                </div>
            </div>
        </section>-->

        <section class="row justify-content-center generic-section align-content-center" id="faq-section">
            <div class="col-12" :class="siteCols">
                <div class="row mb-5">
                    <div class="col-12 col-lg-6 align-self-end">
                        <h3>{{ $t('faqSection.title') }}</h3>
                    </div>
                    <div class="col-12 col-lg-6 text-center text-md-left">
                        <img src="../assets/img/item-faq.jpg">
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <accordion :items="faqItems" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Accordion from "../components/Accordion";
import {mapState} from "vuex";

export default {
    name: 'Home',
    components: {Accordion},
    data: () => ({
        searchEngine2Expanded: false,
        stats: [
            {name: 'dailyStatsSection.stats1', icon: 'icon-stats-search', num: ' ۶+ میلیون'},
            {name: 'dailyStatsSection.stats2', icon: 'icon-stats-response-time', num: '۳۶ میلی‌ثانیه'},
            {name: 'dailyStatsSection.stats3', icon: 'icon-stats-percent', num: '۵۰+ درصد'},
        ],

        faqItems: [
            {id: 1, title: 'faqItems.item1.title', description: 'faqItems.item1.description'},
            {id: 2, title: 'faqItems.item2.title', description: 'faqItems.item2.description'},
            {id: 3, title: 'faqItems.item3.title', description: 'faqItems.item3.description'},
            {id: 4, title: 'faqItems.item4.title', description: 'faqItems.item4.description'},
            {id: 5, title: 'faqItems.item5.title', description: 'faqItems.item5.description'},
            {id: 6, title: 'faqItems.item6.title', description: 'faqItems.item6.description'},
            {id: 7, title: 'faqItems.item7.title', description: 'faqItems.item7.description'},
            {id: 8, title: 'faqItems.item8.title', description: 'faqItems.item8.description'},
            {id: 9, title: 'faqItems.item9.title', description: 'faqItems.item9.description'},
            {id: 10, title: 'faqItems.item10.title', description: 'faqItems.item10.description'},
            {id: 11, title: 'faqItems.item11.title', description: 'faqItems.item11.description'},
            {id: 12, title: 'faqItems.item12.title', description: 'faqItems.item12.description'},
            {id: 13, title: 'faqItems.item13.title', description: 'faqItems.item13.description'},
            {id: 14, title: 'faqItems.item14.title', description: 'faqItems.item14.description'},
        ]
    }),
    computed: {
        ...mapState({
            siteCols: state => state.settings.siteCols
        }),
    },
    methods: {
        expandSearchEngine2() {
            this.searchEngine2Expanded = true
        }
    }
}
</script>

<style scoped>
/* search engine section */
#search-engine-section {
    background: url('../assets/img/item-search-engine.jpg') top left no-repeat;
    background-size: contain;
    min-height: 600px;
}

#search-engine-section h3 {
    font-size: 40px;
    font-weight: bold;
    color: #0ea960;
}

#search-engine-section p {
    font-weight: 500;
    color: #454545;
}

#search-engine-section-2 {
    margin-top: 130px;
    margin-bottom: 90px;
}

@media (max-width: 1300px) {
    #search-engine-section {
        background-size: cover;
    }
}

@media (max-width: 991.98px) {
    #search-engine-section {
        padding-top: 50px;
        padding-bottom: 50px;
        min-height: 430px;
        background: url('../assets/img/item-hero-mobile.jpg') no-repeat bottom left;
        background-size: cover;
        align-content: space-between !important;
    }

    #search-engine-section .col-12 {
        min-height: 430px;
    }

    #search-engine-section h3 {
        font-size: 30px;
    }

    #search-engine-section p {
        line-height: 40px;
    }

    #search-engine-section .btn {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
    }

    #search-engine-section-2 {
        position: relative;
        margin-top: 60px;
        margin-bottom: 50px;
        max-height: 650px;
        align-content: start !important;
        overflow: hidden;
    }

    #search-engine-section-2.expanded {
        max-height: none;
    }

    #search-engine-section-2:after {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 200px;
        background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffff);
        content: '';
    }

    #search-engine-section-2.expanded:after {
        content: none;
    }

    #search-engine-section-2 #more-information {
        display: block !important;
        position: absolute;
        top: 550px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 11;
    }
}

/* generic section */
.generic-section h3 {
    font-size: 36px;
    font-weight: bold;
    color: #212121;
}

.generic-section p {
    font-weight: 300;
    color: #454545;
}

@media (max-width: 991.98px) {
    .generic-section h3 {
        font-size: 30px;
    }

    .generic-section p {
        line-height: 40px;
    }
}

/* daily stats section */
#daily-stats-section {
    background-color: rgba(233, 242, 240, 0.6);
    padding-top: 100px;
    padding-bottom: 100px;
}

#daily-stats-section h3 {
    margin-bottom: 52px;
}

#daily-stats-section .icon {
    width: 92px;
    height: 92px;
}

#daily-stats-section .stat-num {
    font-weight: 300;
    font-size: 40px;
    color: #0ea960;
    display: flex;
    justify-content: center;
    line-height: 60px;
}

#daily-stats-section .stat-label {
    font-size: 20px;
    color: #212121;
    display: flex;
    justify-content: center;
    font-weight: 500;
    margin-top: 8px;
}

@media (max-width: 991.98px) {
    #daily-stats-section {
        padding-top: 50px;
        padding-bottom: 50px;
    }

    #daily-stats-section .stat-num {
        margin-bottom: 30px;
    }
}

/* keywords section */
#keywords-section {
    padding-top: 120px;
    padding-bottom: 120px;
}

#keywords-section .badge {
    display: inline-block;
    height: 50px;
    line-height: 50px;
    padding: 0 30px;
    background-color: #0ea960;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    color: #ffffff;
}

#keywords-section h3 {
    margin: 30px 0;
}

@media (max-width: 991.98px) {
    #keywords-section {
        padding-top: 50px;
        padding-bottom: 50px;
    }

    #keywords-section h3 {
    }
}

/* gif video */
.gif-video {
    position: relative;
}

.gif-video img,
.gif-video video {
    position: absolute;
    top: 0;
    left: 10%;
    width: 80%;
}

.gif-video img:first-child {
    position: relative;
    left: 0;
    display: block;
    margin: 0 auto;
}

.gif-video video {
    width: 47.5%;
    top: 12%;
    left: 26%;
    border-radius: 25px;
}

/* new apps section */
#new-apps-section {
    margin-top: 120px;
    margin-bottom: 150px;
}

#new-apps-section h3 {
    margin-bottom: 30px;
}

@media (max-width: 991.98px) {
    #new-apps-section {
        margin-top: 60px;
        margin-bottom: 70px;
    }
}

/* indexer section */
#indexer-section {
    margin-top: 110px;
    margin-bottom: 110px;
}

/* faq section */
#faq-section {
    margin-top: 150px;
}

#faq-section img {
    position: relative;
    left: 0;
    bottom: -20px;
    width: 226px;
}

@media (max-width: 991.98px) {
    #faq-section {
        margin-top: 70px;
    }

    #faq-section img {
        bottom: 0;
        margin-top: 25px;
        margin-bottom: 25px;
    }
}
</style>
